import * as types from "../../constants/FieldType";
import * as FieldType from "../../constants/FieldType";
import {EditPlace, linkToRef, ReportLauncherPlace} from "../../routing/places";
import * as ts from "../../common/Translator";
import {translateId, translateIdAr, translateIdEn, translateRef} from "../../common/Translator";
import * as Formats from "../../constants/Formats";
import * as commonFields from "../../constants/CommonFieldIds";
import * as ViewMode from "../../constants/ViewMode";
import * as BSEntities from "../../constants/BSEntities";
import * as ConstantViewNames from "../../constants/ConstantViewNames";
import {areEqual, getFirstNotEmptyObj, namaCompare} from "../../common/NamaCommon";
import {NamaRouterInstance} from "../../routing/NamaRouter";
import {getColAggregates_, getColLocked, getColOrder, getColWidth, reorderColumns, setColHidden, setColLocked, setColWidth} from "../StorageUtil";
import {addImgPartToName} from "../../common/AttachmentLinkUtil";
import * as ShowImageIn from "../../constants/ShowImageIn";
import {ListPresenter} from "../../routing/ListPresenter";
import {calcForecolor, colorCode, shouldShowImageOnHover} from "../../common/GUIUtilities";
import {PreviewPopupView} from "../PreviewPopupView";
import {
    colMenuBuilder,
    fetchColId,
    gridGroupFooterTemp,
    isColHidden,
    resizeGroupHeadersWidthsIfNeeded,
    updateDataSrcAggregates
} from "../../grid/NamaGridWidget";
import {findFieldMetadata} from "../../common/Metadata";
import moment from "moment/moment";
import {calcAttachmentHREF} from "../../widgets/AttachmentWidget";
import {getFieldDisplayMask, isFieldValuesRestricted} from "../../login/ClientCache";
import {dropDownFiltering, prepareAllowedValues} from "../../widgets/DropDownListWidget";
import {sortData} from "../../widgets/GenericReferenceWidget";
import {addTimeZoneOffsetToDate} from "../../widgets/TimeFieldWidget";
import {normalizeArabic} from "../../common/StringUtils";
import {JSCriteriaBuilder} from "../../common/JSCriteriaBuilder";
import {SimpleEntityView} from "../edit/SimpleEntityView";
import * as SimpleEntities from "../../constants/SimpleEntities";

let templates = new Map();
let titleCalculators = new Map();
templates.set(types.Date, dateTemplate)
templates.set(types.DateAndTime, dateTimeTemplate)
templates.set(types.Time, timeTemplate)
templates.set(types.BigText, textColumn);
templates.set(types.Reference, referenceColumn);
templates.set(types.Genericreference, referenceColumn);
templates.set(types.ID, idColumn);
templates.set(types.EntityType, entityTypeColumn);
templates.set(types.Enum, entityTypeColumn);
templates.set(types.FeatureID, entityTypeColumn);
templates.set(types.Boolean, booleanColumn);
templates.set(types.Binary, attachColumn);

titleCalculators.set(types.Reference, referenceColoumnTitleCalculator);
titleCalculators.set(types.Genericreference, referenceColoumnTitleCalculator);
titleCalculators.set(types.ID, referenceColoumnTitleCalculator);

function dateTemplate(fieldId) {
    return (dataItem) => {
        let date = dataItem.values[fieldId];
        if (!date)
            return '';
        date = date.substring(0, Formats.DATE_FORMAT.length)
        return date;
    }
}

function timeTemplate(fieldId) {
    return (dataItem) => {
        let date = dataItem.values[fieldId];
        if (!date)
            return '';
        return addTimeZoneOffsetToDate(date);
    }
}

function dateTimeTemplate(fieldId) {
    return (dataItem) => {
        let date = dataItem.values[fieldId];
        if (!date)
            return '';
        date = date.substring(0, Formats.DATE_SERVER_FORMAT.length)
        return date;
    }
}

function textColumn(fieldId, entityType) {
    return (dataItem) => {
        let text = dataItem.values[fieldId];
        if (!text)
            return '';
        let format = getFieldDisplayMask(entityType, fieldId);
        if (format)
            return kendo.toString(text, format);
        return text;
    }
}

function unFormattedTextColumn(fieldId) {
    return function () {
        let dataItem = this;
        if (!dataItem || !dataItem.values)
            return "";
        return dataItem.values[fieldId];
    }
}

function booleanColumn(fieldId) {
    return (dataItem) => {
        let text = dataItem.values[fieldId];
        if (!text)
            return ts.translateId("_false");
        return ts.translateId("_true");
    }
}

function attachColumn(fieldId, entityType) {
    return (dataItem) => {
        let value = dataItem.values[fieldId];
        if (!value)
            return "";
        let previewPart = previewImageCodeForAttachmentWidget(entityType, null, value.attachmentInfo.fileId, value.attachmentInfo.fileName, false);
        return `<a href=${calcAttachmentHREF(value)} ${previewPart}>${value.attachmentInfo.fileName}</a>`;
    }
}

function entityTypeColumn(fieldId) {
    return (dataItem) => {
        let text = dataItem.values[fieldId];
        if (!text)
            return '';
        return ts.translateId(text);
    }
}

function referenceInfoColumn(fieldId, infoId, applier) {
    return function () {
        let dataItem = this;
        let ref = dataItem.values[fieldId];
        if (fieldId === "id")
            ref = dataItem.values;
        if (!ref)
            return "";
        let info = ref[infoId] ? ref[infoId] : "";
        return applier ? applier(info) : info;
    }
}

function referenceColumn(fieldId) {
    return (dataItem) => {
        if (fieldId === "parent")
            fieldId = "gui2Parent";
        let ref = dataItem.values[fieldId];
        if (!ref || !ref.id)
            return "";
        let refColorCode = colorCode(ref);
        let refColorCodePart = refColorCode ? ` style='background-color: ${refColorCode + ";color:" + calcForecolor(refColorCode)}' `:"";
        return `<a class="nama-link" ${refColorCodePart} href="${linkToRef(ref)}">${translateRef(ref)}</a>`;
    }
}

function referenceColoumnTitleCalculator(fieldId) {
    return function () {
        let dataItem = this;
        let ref = dataItem.values[fieldId];
        if (fieldId === "id")
            ref = dataItem.values;
        if (!ref)
            return "";
        return translateRef(ref);
    }
}

export function previewImageCode(entityType, id, attachId) {
    if ((!id && !attachId) || !shouldShowImageOnHover(entityType))
        return "";
    return ` onmouseout='previewAttachmentMouseOut(this);' onmouseover='previewAttachment(this,"${attachId ? attachId : ""}","${entityType}","${id}");'`;
}

export function previewImageCodeForAttachmentWidget(entityType, id, attachId, fileName, callOnly) {
    let call = `previewAttachment(this,"${attachId ? attachId : ""}","${entityType}","${id}","${fileName}");`;
    if (callOnly)
        return call;
    return ` onmouseover='${call}'`;
}

function idColumn() {
    return (dataItem) => {
        let values = dataItem["values"] || [];
        let entityType = values[commonFields.ENTITY_TYPE];
        let id = values[commonFields.ID];
        let place = null;
        let presenter = NamaRouterInstance.currentPresenter;
        let listViewName = presenter.place.listViewName;
        if (areEqual(entityType, BSEntities.ReportDefinition)
            && areEqual(listViewName, ConstantViewNames.REPORT_CATALOGUE_SCREEN_NAME)) {
            place = new ReportLauncherPlace();
            place.reportId = id;
        } else if (areEqual(listViewName, ConstantViewNames.EMPLOYEE_APPROVALS_SCREEN_NAME)) {
            return `<a id = "approveCurrent" class='k-button k-button-icon'><span class='fa fa-thumbs-o-up' style='width: 2em'></span></a>`;
        } else if (areEqual(listViewName, ConstantViewNames.LEDGER_TRANS_SCREEN_NAME)) {
            return `<a id = "transIdCol" class='k-button k-button-icon' onclick='previewSimpleEntity("${id}");'><span class='k-icon k-i-txt' style='width: 2em'></span></a>`;
        } else {
            place = new EditPlace({parentPlace: presenter.place, copyFromPlace: true, currentEntityType: entityType});
            place.entityType = entityType;
            place.id = id;
            place.view = ViewMode.EDIT;
        }
        let title = ts.translateRef(values);
        let link = `<a class ="nama-link" href="${place.fullLink()}"`;
        link += previewImageCode(entityType, id);
        link += `>${title}</a>`;
        let showIn = presenter && presenter instanceof ListPresenter ? ShowImageIn.ListView : ShowImageIn.SearcherView;
        return addImgPartToName(entityType, id, link, showIn, values);
    }
}

window.previewSimpleEntity = function (id) {
    let criteria = new JSCriteriaBuilder();
    criteria = criteria.field(commonFields.ID).equal(id);
    new SimpleEntityView(SimpleEntities.LedgerTrans, criteria);
}

export let previewPopupView;
window.previewAttachmentMouseOut = function () {
    if (previewPopupView)
        previewPopupView.off();
}

export function removeCurrentPopup() {
    previewPopupView = null;
}

window.previewAttachment = function (element, attachmentId, entityType, id, fileName) {
    setTimeout(() => {
        if (!previewPopupView)
            previewPopupView = new PreviewPopupView(attachmentId, id, entityType, element, fileName);
        previewPopupView.previewByRecordId()
    }, 500);

}

function createListViewColumnTemplate(fieldMetdata, id, ownerEntityType) {
    let template = templates.get(fieldMetdata.fieldType);
    if (!template)
        template = textColumn;
    return template(id, ownerEntityType);
}

function listViewTitleCalculator(fieldMetdata, id, ownerEntityType) {
    let titleCalculator = titleCalculators.get(fieldMetdata.fieldType);
    if (!titleCalculator) {
        let template = createListViewColumnTemplate(fieldMetdata, id, ownerEntityType);
        return function () {
            return template(this);
        };
    }
    return titleCalculator(id);
}

export function constructDataFromAllowedValues(allowedValues, prefix) {
    if (!prefix)
        prefix = "";
    let data = [{value: "", text: "", arabicText: "", englishText: "", originText: "", searchData: ""}];
    for (let allowedValue of allowedValues) {
        let arabic = translateIdAr(prefix + allowedValue).trim();
        let english = translateIdEn(prefix + allowedValue).trim();
        data.push({
            value: allowedValue,
            text: translateId(prefix + allowedValue),
            originText: prefix + allowedValue,
            arabicText: arabic,
            englishText: english,
            searchData: allowedValue + " " + arabic + " " + english + " " + normalizeArabic(arabic)
        });
    }
    sortData(data);
    return data;
}

function enumUI(colMetaData) {
    let allowedValues = prepareAllowedValues(colMetaData);
    let data = constructDataFromAllowedValues(allowedValues);
    return (element) => element.kendoDropDownList({
        dataSource: data,
        dataTextField: "text",
        dataValueField: "text",
        filter: "contains",
        filtering: function (ev) {
            dropDownFiltering(ev, this.dataSource);
        }
    });
}

export function fetchFilteringUIFor(colMetaData, entityType) {
    let fieldType = colMetaData.fieldType;
    if (isFieldValuesRestricted(entityType, colMetaData.fieldId))
        return enumUI(colMetaData);
    switch (fieldType) {
        case types.Date:
            return (element) => element.kendoDatePicker({
                format: 'yyyy-MM-dd',
                parseFormats: Formats.DATE_PARSE_FORMAT
            });
        case types.DateAndTime:
            return (element) => element.kendoDateTimePicker();
        case types.Decimal:
        case types.Integer:
        case types.Long:
            return (element) => {
                element.kendoNumericTextBox();
                let mask = getFieldDisplayMask(entityType, colMetaData.fieldId);
                if (mask)
                    element.format = mask;
            }
        case types.Enum:
        case types.EntityType:
        case types.FeatureID:
            return enumUI(colMetaData);
        case types.Boolean:
            return (element) => element.kendoDropDownList({
                dataSource: [{value: true, text: ts.translateId("_true")}, {value: false, text: ts.translateId("_false")}],
                optionLabel: "",
                dataTextField: "text",
                dataValueField: "text"
            });
        default:
            return "";
    }
    return "";
}

/**
 *
 * @param {namaTypes.SearcherScreenLayout|namaTypes.ListScreenLayout} layout
 * @param model
 * @param defaultWidth
 * @param {boolean}addCheckboxColumn
 * @return {kendo.ui.GridColumn[]}
 */
export function createListViewColumns(owner, layout, model, defaultWidth = $(document).width(), addCheckboxColumn = true, editableLineNumber = false) {

    let displayColumns = layout.displayColumns;
    let columns = [gridRowNumberColumn(owner, editableLineNumber)];
    if (addCheckboxColumn) {
        let selectFieldId = "select";
        columns.push({
            id: selectFieldId,
            selectable: true,
            width: getFirstNotEmptyObj(getColWidth(owner, selectFieldId), 30),
            locked: true,
            headerAttributes: {"class": "nama-selectAll-header"},
            order: getColOrder(owner, selectFieldId) || 2,
            attributes: {"class": "grid-check-box"},
        });
    }
    let unifiedWidth = '10em';
    if (defaultWidth) {
        let colsLength = displayColumns.filter(c => c.displayed).length;
        unifiedWidth = defaultWidth / colsLength;
    }
    let i = columns.length + 1;
    let ownerEntityType = owner.presenter && owner.presenter.place ? owner.presenter.place.entityType : "";
    for (let displayColumn of displayColumns) {
        if (displayColumn.displayed) {
            if (!displayColumn.metaData)
                displayColumn.metaData = {fieldType: types.Reference};
            let fieldId = displayColumn.id;
            let validId = toValidId(fieldId);
            let fieldType = displayColumn.metaData.fieldType;
            let colType = namaTypeToKendoColumnType(fieldType);
            let numberCol = fieldType === types.Decimal || fieldType === types.Long || fieldType === types.Integer;
            if (fieldType === types.Reference || fieldType === types.Genericreference) {
                let codeColId = fieldId + ".code";
                columns.push({
                    id: fieldId,
                    field: toValidId(codeColId) + "()",
                    title: displayColumn.title ? ts.translateNaMaText(displayColumn.title) : ts.translate(fieldId, ownerEntityType),
                    hidden: true,
                    menu: false
                });
            } else if (numberCol) {
                let unformattedColId = fieldId + ".unformatted";
                columns.push({
                    id: fieldId,
                    field: toValidId(unformattedColId) + "()",
                    title: displayColumn.title ? ts.translateNaMaText(displayColumn.title) : ts.translate(fieldId, ownerEntityType),
                    hidden: true,
                    menu: false
                });
            }
            columns.push({
                id: fieldId,
                field: validId + "()",
                title: displayColumn.title ? ts.translateNaMaText(displayColumn.title) : ts.translate(fieldId, ownerEntityType),
                type: colType,
                width: getFirstNotEmptyObj(getColWidth(owner, fieldId), displayColumn.width, unifiedWidth),
                template: createListViewColumnTemplate(displayColumn.metaData, fieldId, ownerEntityType),
                headerAttributes: {"class": "nama-col-header"},
                locked: getColLocked(owner, fieldId),
                hidden: isColHidden(owner, fieldId),
                order: getColOrder(owner, fieldId) || i,
                filterable: {
                    ui: fetchFilteringUIFor(displayColumn.metaData, ownerEntityType),
                    extra: colType === "boolean" ? false : true,
                }
            });
            let titleCalculator = listViewTitleCalculator(displayColumn.metaData, fieldId, ownerEntityType);
            model[validId] = titleCalculator;
            if (fieldType === types.Reference || fieldType === types.Genericreference) {
                model[validId + "$dashedId"] = referenceInfoColumn(fieldId, "id");
                model[validId + "$nonDashedId"] = referenceInfoColumn(fieldId, "id", idConverter("nonDashedId"));
                model[validId + "$normalId"] = referenceInfoColumn(fieldId, "id", idConverter("normalId"));
                model[validId + "$code"] = referenceInfoColumn(fieldId, "code");
                model[validId + "$altCode"] = referenceInfoColumn(fieldId, "altCode");
                model[validId + "$name1"] = referenceInfoColumn(fieldId, "name1");
                model[validId + "$name2"] = referenceInfoColumn(fieldId, "name2");
            } else if (numberCol) {
                model[validId + "$unformatted"] = unFormattedTextColumn(fieldId);
            }
            i++;
        }
    }
    columns.sort((o1, o2) => namaCompare(o1.order, o2.order));
    for (let col of columns) {
        let idOfGroupedCol = fetchColId(col);
        col.groupFooterTemplate = gridGroupFooterTemp(idOfGroupedCol, "()", owner);
        col.footerTemplate = gridGroupFooterTemp(idOfGroupedCol, "()", owner);
        let colAggregates_ = getColAggregates_(owner.presenter, idOfGroupedCol);
        if (!colAggregates_) {
            col.aggregates = [];
        } else {
            let aggregates = colAggregates_.split(",");
            col.aggregates = aggregates.map(a => a.toLowerCase());
        }
    }
    return columns;
}

let idConverters = new Map();

export function idConverter(fieldId) {
    if (idConverters.length)
        return idConverters.get(fieldId);
    idConverters.set("nonDashedId", (id) => id.replaceAll("-", ""));
    idConverters.set("normalId", (id) => id = "0x" + id);
}

export function namaTypeToKendoColumnType(namaType) {
    switch (namaType) {
        case types.Date:
            return "date";
        case types.DateAndTime:
            return "date";
        case types.Decimal:
            return "number";
        case types.Integer:
            return "number";
        case types.Long:
            return "number";
        case types.Boolean:
            return "boolean";
        case types.Enum:
        case types.EntityType:
        case types.FeatureID:
            return "enum";
        default:
            return "text";
    }
    return "text";
}

function toValidId(id) {
    return "$" + id.replaceAll(".", "$");
}

export function toNormalId(id) {
    return id.substring(1).replaceAll("$", ".").replace("()", "");
}


export function createFilterFor(filter, field, subId) {
    let newFilter = {
        operator: filter.operator,
        field: field.replace("()", "") + subId,
        value: filter.value,
    };
    return newFilter;
}

export function startGrouping(e, presenter, subIdSuffix) {
    if (!e.groups.length)
        return;
    let groupedByRef = false;
    let newGroups = [];
    for (let g of e.groups) {
        let field = toNormalId(g.field);
        let fieldMetaData = findFieldMetadata(field, presenter.metaData);
        if (!fieldMetaData)
            continue;
        if (fieldMetaData && (fieldMetaData.fieldType === FieldType.Reference || fieldMetaData.fieldType === FieldType.Genericreference)) {
            groupedByRef = true;
            newGroups.push({
                field: g.field.replace("()", "") + "$code" + subIdSuffix
                , dir: g.dir, aggregates: g.aggregates
            });
        } else {
            newGroups.push(g);
        }
    }
    if (groupedByRef) {
        e.preventDefault();
        e.sender.dataSource.group(newGroups);
    }
}

function isEnum(fieldType, entityType, fieldId) {
    return fieldType === types.Enum || fieldType === types.EntityType || fieldType === types.FeatureID || isFieldValuesRestricted(entityType, fieldId)
}

export function startFilter(e, presenter, subIdSuffix) {
    let allFilters = e.sender.dataSource.filter() || {logic: "and", filters: []};
    for (let i = allFilters.filters.length - 1; i >= 0; i--) {
        if (allFilters.filters[i].field === e.field) {
            allFilters.filters.splice(i, 1);
            continue
        }
        let filters = allFilters.filters[i].filters;
        if (!filters)
            continue;
        if (filters.filter(f => f.field === e.field).length > 0)
            allFilters.filters.splice(i, 1);
    }
    let currentFilter = e.filter;
    if (currentFilter && currentFilter.filters) {
        for (let filter of currentFilter.filters) {
            let field = toNormalId(filter.field);
            let fieldMetaData = findFieldMetadata(field, presenter.metaData);
            if (!fieldMetaData)
                continue;
            let filterVal = filter.value;
            if (fieldMetaData.fieldType === types.Genericreference || fieldMetaData.fieldType === types.Reference) {
                filter.filters = [];
                filter.logic = "or";
                filter.filters.push(createFilterFor(filter, filter.field, "$dashedId" + subIdSuffix));
                filter.filters.push(createFilterFor(filter, filter.field, "$nonDashedId" + subIdSuffix));
                filter.filters.push(createFilterFor(filter, filter.field, "$normalId" + subIdSuffix));
                filter.filters.push(createFilterFor(filter, filter.field, "$altCode" + subIdSuffix));
                filter.filters.push(createFilterFor(filter, filter.field, "$code" + subIdSuffix));
                filter.filters.push(createFilterFor(filter, filter.field, "$name1" + subIdSuffix));
                filter.filters.push(createFilterFor(filter, filter.field, "$name2" + subIdSuffix));
            }
            if (isEnum(fieldMetaData.fieldType, presenter.entityType, field)) {
                filter.value = filterVal ? ts.translateId(filterVal) : "";
            }
            if (fieldMetaData.fieldType === types.Date || fieldMetaData.fieldType === types.DateAndTime) {
                let date = new moment(filterVal, Formats.DATE_MOMENT_SERVER_FORMAT);
                let format = date.format(Formats.DATE_MOMENT_SERVER_FORMAT);
                filter.value = format.substring(0, Formats.DATE_FORMAT.length);
            }
            if (fieldMetaData.fieldType === types.Decimal || fieldMetaData.fieldType === types.Integer || fieldMetaData.fieldType === types.Long) {
                filter.filters = [];
                filter.logic = "or";
                filter.filters.push({
                    operator: filter.operator,
                    field: filter.field.replace("()", "") + "$unformatted" + subIdSuffix,
                    value: filter.value,
                });
            }
        }
        e.preventDefault();
        allFilters.filters.push(currentFilter);
    }
    e.sender.dataSource.filter(allFilters);
}

/**
 *
 * @param {NamaGridOwner} owner
 * @param defaultColumnsHeight
 * @param {boolean | string}selectable
 */

export function initKendoGrid(owner, defaultColumnsHeight = "100%", selectable = "") {
    let that = owner;
    let rootElement = that.rootElement;
    let gridElementId = "#grid";
    if (rootElement.find(gridElementId).data("kendoGrid")) {
        rootElement.find(gridElementId).data().kendoGrid.destroy();
        rootElement.find(gridElementId).empty();
    }
    that.dataSource = new kendo.data.DataSource({
        transport: {
            read: (options) => {
                that.readFromServer(options);
            }
        },
        pageSize: owner.calcPageSize() || 25,
        page: owner.calcCurrentPage(),
        serverPaging: true,
        schema: {
            data: "page", total: "totalRecordsCount",
            model: owner.model
        }
    });
    updateDataSrcAggregates(owner.displayColumns, that.dataSource, owner);
    localStorage.setItem((that.autoFitLocalStorageKey() + "AutoFitApplied"), "false");
    rootElement.find(gridElementId).kendoGrid({
        dataSource: that.dataSource,
        columns: owner.displayColumns,
        height: defaultColumnsHeight,
        sortable: true,
        pageable: {
            position: "top",
            refresh: true,
            pageSizes: [25, 50, 75, 100, "all"],
            buttonCount: 5
        },
        navigatable: false,
        selectable: selectable,
        reorderable: true,
        filterable: true,
        autoSync: true,
        autoBind: true,
        groupable: {
            messages: {empty: "Drag columns to group by"}
        },
        resizable: true,
        columnMenu: true,
        allowCopy: true,
        width: "100%",
        dataBound: function () {
            if (!that.autoFitGridColumns || !that.autoFitLocalStorageKey || (that.autoFitGridColumns && that.autoFitLocalStorageKey && that.dataSource.data().length && (localStorage.getItem(that.autoFitLocalStorageKey() + "AutoFitApplied")) != "true")) {
                gridDataBoundForRowNumber(this);
                if (that.autoFitGridColumns && that.autoFitLocalStorageKey && that.dataSource.data().length && localStorage.getItem(that.autoFitLocalStorageKey()) == "true")
                    that.autoFitGridColumns();
                resizeGroupHeadersWidthsIfNeeded(rootElement.find(gridElementId).data("kendoGrid"));
            }
        },
        columnResize: function (e) {
            if (that.autoFitLocalStorageKey)
                localStorage.setItem(that.autoFitLocalStorageKey(), "false");
            setColWidth(owner, e);
        },
        columnLock: function (e) {
            setColLocked(owner, e, true);
        },
        columnUnlock: function (e) {
            setColLocked(owner, e, false);
        },
        columnShow: function (e) {
            setColHidden(owner, e, false);
        },
        columnHide: function (e) {
            setColHidden(owner, e, true);
        },
        columnReorder: function (e) {
            reorderColumns(owner, rootElement.find(gridElementId).data("kendoGrid"));
        },
        filter: function (e) {
            startFilter(e, owner.presenter, "()");
        },
        group: function (e) {
            startGrouping(e, owner.presenter, "()");
        },
        columnMenuInit: function (e) {
            colMenuBuilder(e, {
                metaData: owner.presenter.metaData,
                owner: owner
            }, owner.displayColumns, false, "()", rootElement.find(gridElementId).data("kendoGrid"));
        }
    });
}

export function fillFilterOperatorsForField(dropDownElement, fieldMetaData, entityType) {
    if (!fieldMetaData || !dropDownElement.length)
        return;
    let dropDownData = dropDownElement.data("kendoDropDownList");
    let operatorList = [{text: ts.translateId("Contains"), value: "contains"},
        {text: ts.translateId("NotContain"), value: "doesnotcontain"}, {text: ts.translateId("Equal"), value: "eq"}
        , {text: ts.translateId("NotEqual"), value: "neq"}, {text: ts.translateId("NotContain"), value: "StartsWith"},
        {text: ts.translateId("EndsWith"), value: "endswith"}];
    if (fieldMetaData.fieldType === types.Boolean || fieldMetaData.fieldType === types.Enum)
        operatorList = [{text: ts.translateId("Equal"), value: "eq"}, {text: ts.translateId("NotEqual"), value: "neq"}];
    if (isEnum(fieldMetaData.fieldType, entityType, fieldMetaData.fieldId))
        operatorList = [{text: ts.translateId("Contains"), value: "contains"},
            {text: ts.translateId("NotContain"), value: "doesnotcontain"}, {
                text: ts.translateId("Equal"),
                value: "eq"
            }, {text: ts.translateId("NotEqual"), value: "neq"}];
    if (fieldMetaData.fieldType === types.Date || fieldMetaData.fieldType === types.DateAndTime || fieldMetaData.fieldType === types.Integer || fieldMetaData.fieldType === types.Decimal)
        operatorList = [{text: ts.translateId("Equal"), value: "eq"}, {text: ts.translateId("NotEqual"), value: "neq"},
            {text: ts.translateId("GreaterThan"), value: "gt"}, {text: ts.translateId("GreaterThanOrEqual"), value: "gte"},
            {text: ts.translateId("LessThan"), value: "lt"}, {text: ts.translateId("LessThanOrEqual"), value: "lte"}];
    let operators = new kendo.data.DataSource({
        data: operatorList
    });
    dropDownData.setDataSource(operators);
}

function movePagerTop(owner) {
    let rootElement = owner.rootElement;
    let grid = rootElement.find("#grid").data("kendoGrid");
    if (grid && !grid.pagerTop) {
        let wrapper = $('<div class="k-pager-wrap k-grid-pager pagerTop"/>').insertBefore(grid.element.children(".k-grouping-header"));
        grid.pagerTop = new kendo.ui.Pager(wrapper, $.extend({}, grid.options.pageable, {dataSource: grid.dataSource}));
        grid.element.find(".pagerTop").css("border-width", "0 0 1px 0");
        grid.element.find(".k-pager-wrap").last().hide();
    }
}

export function currentRowAbsoluteNumber(grid) {
    let firstIndex = 0;
    if (grid.dataSource.pageSize())
        firstIndex = (grid.dataSource.page() - 1) * grid.dataSource.pageSize();
    return firstIndex + (grid.current().parent().index() || 0) + 1;
}

export function gridDataBoundForRowNumber(grid) {
    let rows = grid.items();
    let firstIndex = 0;
    if (grid.dataSource.pageSize())
        firstIndex = (grid.dataSource.page() - 1) * grid.dataSource.pageSize();
    $(rows).each(function () {
        let index = firstIndex + $(this).index() + 1;
        let rowLabel = grid.lockedTable.find(".row-number")[$(this).index()];
        $(rowLabel).text(index);
        if ($(rowLabel).hasClass("k-textbox"))
            $(rowLabel).val("1");
        let dataItem = grid.dataItem(this);
        let namaStyle = dataItem.namaStyle;
        if (!namaStyle && dataItem.values)
            namaStyle = dataItem.values.namaStyle;
        if (namaStyle)
            $(this).addClass(namaStyle);
        let rowBackgroundColor = dataItem.rowBackgroundColor;
        if (!rowBackgroundColor && dataItem.values)
            rowBackgroundColor = dataItem.values.rowBackgroundColor;
        let namaRowBackgroundColor = dataItem.namaRowBackgroundColor;
        if (!namaRowBackgroundColor && dataItem.values)
            namaRowBackgroundColor = dataItem.values.namaRowBackgroundColor;
        if (rowBackgroundColor || namaRowBackgroundColor)
            $(this).css("background-color", getFirstNotEmptyObj(namaRowBackgroundColor, rowBackgroundColor));
    });
}

export function gridRowNumberColumn(owner, editableLineNumber) {
    let template = "<span class='row-number'></span>";
    if (editableLineNumber)
        template = "<input class='row-number k-textbox' style='width: 2em'/>";
    let filedId = "colNumber";
    let width = getFirstNotEmptyObj(getColWidth(owner, filedId), "50px");
    return {
        title: "#",
        template: template,
        width: width,
        locked: true,
        hidden: isColHidden(owner, filedId),
        order: getColOrder(owner, filedId) || 1,
        id: filedId,
        editable: function () {
            return editableLineNumber === true;
        }
    };
}